//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ClientListConfig
export const NewLedgerConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/newLedger",
      component: FuseLoadable({
        loader: () => import("./SearchLedger.js")
      })
    }
  ]
  //end routes
};
